import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addFirstAidlist } from './store/index';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';

const languages = ['English', 'Tamil', 'Hindi', 'Telugu', 'Malayalam', 'Kannada'];

const AddFirstAid = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('English');
  const [newFirstAid, setNewFirstAid] = useState(
    languages.reduce((acc, lang) => {
      acc[lang] = { name: '', content: '' };
      return acc;
    }, {})
  );
  const [imageData, setImageData] = useState(null);

  // Handle Tab Change
  const handleTabChange = (lang) => setActiveTab(lang);

  // Handle Input Changes for each language
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFirstAid((prev) => ({
      ...prev,
      [activeTab]: { ...prev[activeTab], [name]: value },
    }));
  };

  // Handle Image File Change
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const modifiedFileName = file.name.replace(/\s+/g, '_');
      const modifiedFile = new File([file], modifiedFileName, { type: file.type });
      setImageData(modifiedFile);
    }
  };

  // Save Data
  const handleAddFirstAid = async () => {
    

    const completeFirstAidData = languages.reduce((acc, lang) => {
      acc[lang] = newFirstAid[lang] || { name: '', content: '' };
      return acc;
    }, {});

      const newEntry = {
    ...completeFirstAidData,
    FirstAidId: uuidv4(),
  };

  

    const formData = new FormData();
    formData.append('img', imageData);
    formData.append('data', JSON.stringify({ newEntry }));

    try {
      // Dispatch the form data directly without wrapping it in another object
      await dispatch(addFirstAidlist(formData)).then((response) => {
        if (response.payload.message === 'Data stored successfully') {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'First Aid details have been added successfully.'
          });
          navigate("/first-aid")
        }
        // Reset the state after submission
        setNewFirstAid(
          languages.reduce((acc, lang) => {
            acc[lang] = { name: '', content: '' };
            return acc;
          }, {})
        );
        setImageData(null);
      })
    } catch (error) {
      console.error('Failed to add first aid entry:', error);
    }
  };

  const isFormValid = newFirstAid[activeTab].name && newFirstAid[activeTab].content && imageData;

  return (
    <div className='icon_backButton'>
      <Link to={"/first-aid"}>
        <i className="fas fa-arrow-alt-circle-left"></i>
      </Link>
      <div className="containers">
        <h2>Add First Aid List</h2>
        <div className="tabers">
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => handleTabChange(lang)}
              className="tabers"
              style={{
                backgroundColor: activeTab === lang ? '#4CAF50' : '#ccc',
              }}
            >
              {lang}
            </button>
          ))}
        </div>
        <div className="commonSection">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="fileInputs"
          />
          {imageData && (
            <img
              src={URL.createObjectURL(imageData)}
              alt="Preview"
              className="imagePreview"
            />
          )}
        </div>
        <div className="formContainers">
          <h3>{activeTab} Details</h3>
          <input
            type="text"
            name="name"
            className="inputs"
            value={newFirstAid[activeTab]?.name || ''}
            onChange={handleInputChange}
            placeholder="Enter First Aid Name"
          />
          <textarea
            name="content"
            className="textareas"
            value={newFirstAid[activeTab]?.content || ''}
            onChange={handleInputChange}
            style={{height:"100px"}}
            placeholder="Enter First Aid Content (HTML Format)"
          />
        </div>
        <button
          className="saveButton"
          onClick={handleAddFirstAid}
          disabled={!isFormValid}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default AddFirstAid;
